import { render, staticRenderFns } from "./SelectMoveDirModal.vue?vue&type=template&id=68230773&scoped=true"
import script from "./SelectMoveDirModal.vue?vue&type=script&lang=js"
export * from "./SelectMoveDirModal.vue?vue&type=script&lang=js"
import style0 from "./SelectMoveDirModal.vue?vue&type=style&index=0&id=68230773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68230773",
  null
  
)

export default component.exports